module.exports = __webpack_public_path__ + "static/bike-b1bee3c416b73b12662f2e232f36a6fe.jpg";